import { makeRequest } from 'utils/requestLogger';

export default (participationID) =>
    makeRequest('put', `/api/participations/${participationID}/opened`);


// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/openParticipation.js